import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  srColumnMappings: [],
  srColumnMappingsLoading: false,
  srTimezone: '',
  srTimezoneLoading: false,
  srProviderMappings: {},
  srProviderMappingLoading: false,
  srUploadEnabledForCurrentUser: false,
  srTypeMappings: [],
  srTypeMappingsLoading: false,
  srTypeList: [],
  srTypeListLoading: false,
  srBulkUploadHistory: [],
  srBulkUploadHistoryLoading: false,
  srStatusMappings: [],
  srStatusMappingsLoading: false,
  srStatusList: [],
  srStatusListLoading: false,
};

const serviceRequestSlice = createSlice({
  name: 'serviceRequestSlice',
  initialState,
  reducers: {
    srColumnMappingsSlice: (state, { payload }) => {
      state.srColumnMappings = payload;
    },
    srColumnMappingsLoadingSlice: (state, { payload }) => {
      state.srColumnMappingsLoading = payload;
    },
    srTimezoneSlice: (state, { payload }) => {
      state.srTimezone = payload;
    },
    srTimezoneLoadingSlice: (state, { payload }) => {
      state.srTimezoneLoading = payload;
    },
    srProviderMappingsSlice: (state, { payload }) => {
      state.srProviderMappings = payload;
    },
    srProviderMappingLoadingSlice: (state, { payload }) => {
      state.srProviderMappingLoading = payload;
    },
    srUploadEnabledForCurrentUserSlice: (state, { payload }) => {
      state.srUploadEnabledForCurrentUser = payload;
    },
    srTypeMappingsSlice: (state, { payload }) => {
      state.srTypeMappings = payload;
    },
    srTypeMappingsLoadingSlice: (state, { payload }) => {
      state.srTypeMappingsLoading = payload;
    },
    srTypeListSlice: (state, { payload }) => {
      state.srTypeList = payload;
    },
    srTypeListLoadingSlice: (state, { payload }) => {
      state.srTypeListLoading = payload;
    },
    srBulkUploadHistorySlice: (state, { payload }) => {
      state.srBulkUploadHistory = payload;
    },
    srBulkUploadHistoryLoadingSlice: (state, { payload }) => {
      state.srBulkUploadHistoryLoading = payload;
    },
    srStatusMappingsSlice: (state, { payload }) => {
      state.srStatusMappings = payload;
    },
    srStatusMappingsLoadingSlice: (state, { payload }) => {
      state.srStatusMappingsLoading = payload;
    },
    srStatusListSlice: (state, { payload }) => {
      state.srStatusList = payload;
    },
    srStatusListLoadingSlice: (state, { payload }) => {
      state.srStatusListLoading = payload;
    },
  },
});

const { actions, reducer } = serviceRequestSlice;

export const {
  srColumnMappingsSlice,
  srColumnMappingsLoadingSlice,
  srTimezoneSlice,
  srTimezoneLoadingSlice,
  srProviderMappingsSlice,
  srProviderMappingLoadingSlice,
  srUploadEnabledForCurrentUserSlice,
  srTypeMappingsSlice,
  srTypeMappingsLoadingSlice,
  srTypeListSlice,
  srTypeListLoadingSlice,
  srBulkUploadHistorySlice,
  srBulkUploadHistoryLoadingSlice,
  srStatusMappingsSlice,
  srStatusMappingsLoadingSlice,
  srStatusListSlice,
  srStatusListLoadingSlice,
} = actions;

export default reducer;
